import React from 'react';
import { motion } from 'framer-motion';
import GradientButton from '../../../components/atoms/GradientButton';
import GradientOutlineButton from '../../../components/atoms/GradientOutlineButton';
import { useMediaQuery } from 'react-responsive';
import Boby_toaung from '../../../assets/images/speech_therapy/girl_showing_toung.jpg';
import { Link } from 'react-router-dom';
function MemberCommunication() {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
  return (
    <div className="w-full flex flex-col justify-between gap-4 sm:gap-10 max-w-[1200px] mx-auto px-4 md:px-10 py-10 md:py-20 relative z-10">
      <div>
        <h2 className="text-[32px] sm:text-[42px] md:text-[48px] text-[#7B54A2] font-bold leading-[40px] lg:leading-[50px] md:mr-4 mb-2">
          Pediatric Speech Therapy{' '}
        </h2>
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.9, ease: 'easeOut' }}
          viewport={{ once: true, amount: 0.5 }}
        >
          <p className="text-[28px] md:text-[32px] xl:text-[34px] text-[#7B54A2] font-bold leading-[35px] md:mr-4">
            Pediatric speech therapy is a specialized field dedicated to helping
            our youngest family members communicate effectively.
          </p>
        </motion.div>
      </div>
      <div className="flex flex-col lg:flex-row justify-between w-full gap-4 xl:gap-32">
        <div className="flex-1 flex flex-col items-start gap-4 sm:gap-6 lg:gap-10 font-custom text-lg md:text-xl 2xl:text-2xl text-secondary">
          <p>
            Pediatric speech therapy can improve many aspects of a child's life,
            through improvements in their social skills, cognitive development,
            their ability to read and write, language acquisition, and
            understanding. When children have the appropriate tools to
            communicate their needs, we see dramatic improvements in their
            overall confidence, their resilience, and other daily challenges.
          </p>
          <p>
            Guidepost offers comprehensive speech and language assessments,
            including thorough evaluations for Dyslexia. Guidepost's pediatric
            speech therapists are professionally trained for early intervention,
            childhood apraxia, expressive and receptive language delays,
            auditory and language processing issues, and oral motor therapy.
          </p>
          <p>
            Through a holistic multi-disciplinary approach, Guidepost pediatric
            speech therapists work with children and parents to address the
            unique needs of every child. By using purposeful and engaging
            therapies and activities, our pediatric speech therapists facilitate
            skill development and empower children to navigate their world with
            confidence.
          </p>
          <p>
            <Link
              to="/contact"
              className="text-[#7F4B9D] underline font-semibold hover:text-[#693c84] transition-colors"
            >
              Contact us today
            </Link>
            &nbsp; to learn more about the world of pediatric occupational
            therapy, explore its core principles, benefits, and the conditions
            it can effectively address. core
          </p>
          <div className="w-full flex flex-col lg:flex-row justify-center items-center gap-5 md:gap-14">
            <GradientOutlineButton
              navigateTo={'/our-team'}
              text="Meet our Therapists"
              width="w-full lg:w-[240px]"
            />
            <GradientButton
              text="Schedule an Evaluation"
              width="w-full lg:w-[240px]"
              navigateTo={'/contact'}
            />
          </div>
        </div>
        <div className="flex-1 flex lg::justify-end justify-center">
          <motion.div
            initial={{ opacity: 0, x: isMobile ? 0 : 300 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, ease: 'easeInOut' }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <img
              src={Boby_toaung}
              alt="Speech therapy articulation practice in Wasilla pediatric clinic"
            />
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default MemberCommunication;
